export default __webpack_public_path__ + "static/media/k_wdt_c_5.afa2fc97.mp3";